module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"entitySearchAutocomplete.label":"Search for a service, subscription, tag...","entitySearchAutocomplete.typePrompt":"Click or type here begin searching...","entitySearchAutocomplete.noDataPrompt":"There are no matching entities, click to search again","entitySearchAutocomplete.createPrompt":"Click to create","entitySearchAutocomplete.saveCustomView":"Save as Custom View"}}')
  delete Component.options._Ctor
}
